import { useStorage } from '@medly-components/utils';
import { createContext, useContext, useEffect, type FC } from 'react';
import { useLocation } from 'react-router-dom';
import type { GuideFiltersContextType } from './types';

export const defaultGuideFilters: GuideFiltersContextType = {
    searchQuery: '',
    guideTypes: [],
    guideAffiliations: [],
    guideCancerTypes: []
};

export const GuideFiltersContext = createContext<[GuideFiltersContextType, React.Dispatch<React.SetStateAction<GuideFiltersContextType>>]>([
    defaultGuideFilters,
    () => null
]);

export const isGuideFiltersApplied = (filters: GuideFiltersContextType): boolean =>
    !!filters.guideTypes.length || !!filters.guideAffiliations.length || !!filters.guideCancerTypes.length;

export const useGuideFilters = () => useContext(GuideFiltersContext)[0];

export const useGuideFiltersContext = () => useContext(GuideFiltersContext);

export const GuideFiltersContextProvider: FC = ({ children }) => {
    const { pathname } = useLocation();
    const [filters, setFilters] = useStorage('guideFilters', {
        initialValue: defaultGuideFilters,
        storage: 'sessionStorage'
    });

    useEffect(() => {
        !pathname.includes('/guides') && setFilters(defaultGuideFilters);
    }, [pathname]);

    return <GuideFiltersContext.Provider value={[filters, setFilters]}>{children}</GuideFiltersContext.Provider>;
};
